<template>
  <div class="top-menu">
    <div class="top-menu__left">
      <svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" width="120.11" height="33.57" viewBox="0 0 120.11 33.57"><defs></defs><g id="Layer_1-2" data-name="Layer 1"><path class="cls-1" d="M85.81,16.89a6.3,6.3,0,0,1-1.61-.21,4.22,4.22,0,0,1-1.31-.56l.66-1.47a4.13,4.13,0,0,0,1.09.5,4,4,0,0,0,1.23.19c.77,0,1.15-.19,1.15-.57a.48.48,0,0,0-.33-.45,6.82,6.82,0,0,0-1-.31,7.94,7.94,0,0,1-1.33-.36,2.33,2.33,0,0,1-.92-.64,1.75,1.75,0,0,1-.38-1.17,2,2,0,0,1,.35-1.15,2.45,2.45,0,0,1,1-.83,4.64,4.64,0,0,1,1.73-.3,6.33,6.33,0,0,1,1.37.16,4.5,4.5,0,0,1,1.19.45l-.62,1.48a4.25,4.25,0,0,0-2-.54,1.65,1.65,0,0,0-.87.18.53.53,0,0,0-.27.45.46.46,0,0,0,.32.43,5.17,5.17,0,0,0,1,.29,11.88,11.88,0,0,1,1.33.37,2.37,2.37,0,0,1,.92.63,1.61,1.61,0,0,1,.39,1.16,2,2,0,0,1-.35,1.15,2.44,2.44,0,0,1-1.06.82A4.17,4.17,0,0,1,85.81,16.89Z"/><path class="cls-1" d="M96.88,11.2a2.17,2.17,0,0,1,1.61.6,2.51,2.51,0,0,1,.6,1.83v3.12H97.2V13.94a1.45,1.45,0,0,0-.22-.85.75.75,0,0,0-.61-.27.87.87,0,0,0-.69.3,1.4,1.4,0,0,0-.27.92v2.71H93.5V13.94c0-.75-.28-1.12-.83-1.12a.9.9,0,0,0-.7.3,1.4,1.4,0,0,0-.27.92v2.71H89.77V11.29h1.82v.57a2.09,2.09,0,0,1,.72-.49,2.67,2.67,0,0,1,.92-.17,2.59,2.59,0,0,1,1,.21,1.77,1.77,0,0,1,.73.65,2.34,2.34,0,0,1,.82-.64A2.77,2.77,0,0,1,96.88,11.2Z"/><path class="cls-1" d="M102.63,11.2a3.09,3.09,0,0,1,2.08.62,2.38,2.38,0,0,1,.71,1.9v3h-1.78V16a1.65,1.65,0,0,1-1.62.79,2.29,2.29,0,0,1-1.09-.22,1.69,1.69,0,0,1-.71-.59,1.74,1.74,0,0,1-.23-.87,1.4,1.4,0,0,1,.59-1.2,3.3,3.3,0,0,1,1.84-.43h1.09c0-.58-.42-.87-1.16-.87a2.73,2.73,0,0,0-.8.13,2.28,2.28,0,0,0-.68.34l-.65-1.3a4,4,0,0,1,1.1-.46A5.78,5.78,0,0,1,102.63,11.2Zm-.07,4.43a.91.91,0,0,0,.58-.16.79.79,0,0,0,.37-.47v-.47h-.83c-.56,0-.84.18-.84.55a.5.5,0,0,0,.19.4A.84.84,0,0,0,102.56,15.63Z"/><path class="cls-1" d="M108.45,12a1.9,1.9,0,0,1,.75-.57,3.07,3.07,0,0,1,1.08-.19v1.72h-.43a1.36,1.36,0,0,0-1,.34,1.37,1.37,0,0,0-.34,1v2.51h-1.92V11.29h1.82Z"/><path class="cls-1" d="M115,16.53a1.82,1.82,0,0,1-.6.23,2.56,2.56,0,0,1-.73.08,2.32,2.32,0,0,1-1.65-.52,2,2,0,0,1-.57-1.56V12.92h-.8V11.49h.8V10.07h1.91v1.42h1.25v1.43h-1.25v1.82a.67.67,0,0,0,.15.46.54.54,0,0,0,.43.16.92.92,0,0,0,.58-.17Z"/><path class="cls-2" d="M74,9.13h1.85v18H74Z"/></g><g id="Layer_2" data-name="Layer 2"><path class="cls-1" d="M88.41,27.14H83.33V19.81h5.08v1.57H85.48v1.3H88.2v1.48H85.5v1.45h2.93Z"/><path class="cls-1" d="M92.37,24.91l1.37-3.24h2l-2.42,5.47H91.43L89,21.67h2Z"/><path class="cls-1" d="M101.85,24.38a3.08,3.08,0,0,1-.07.61h-4a1.28,1.28,0,0,0,1.38.9,2.62,2.62,0,0,0,1.66-.58l.72,1.06a3.55,3.55,0,0,1-2.6.94,2.83,2.83,0,0,1-3-2.67,1.77,1.77,0,0,1,0-.23,2.92,2.92,0,0,1,2.94-2.88h.06a2.64,2.64,0,0,1,2.91,2.31A2.44,2.44,0,0,1,101.85,24.38Zm-4.1-.53h2.37A1.12,1.12,0,0,0,99,22.93a1.2,1.2,0,0,0-1.22.91Z"/><path class="cls-1" d="M104.55,21.67v.79a3,3,0,0,1,2.11-.94,1.9,1.9,0,0,1,2.08,1.7,1.48,1.48,0,0,1,0,.47v3.45h-1.84V24.38c0-.76-.3-1.07-.85-1.07a2,2,0,0,0-1.34.74v3.1h-1.84V21.67Z"/><path class="cls-1" d="M112.41,19.81v1.86h1.53v1.47h-1.53v2c0,.47.16.64.54.64a2.61,2.61,0,0,0,1-.23V27a5.09,5.09,0,0,1-1.73.27c-1.1,0-1.64-.57-1.64-2V23.14h-1V21.67h1V19.81Z"/></g><path class="cls-2" d="M74,9.08h1.87V27.23H74Z"/><path class="cls-3" d="M17.64,15.27a6.08,6.08,0,0,0-1.5-.94,5.39,5.39,0,0,0,.59-.58,5.13,5.13,0,0,0-3.91-8.5H5.48V27.08H19.72V19.85A6,6,0,0,0,17.64,15.27Zm-.94,10.1H14.11V18.09h-3v7.28H8.5V7h3a3.46,3.46,0,0,1,3.35,2.57H12v1.71h2.91a3.46,3.46,0,0,1-3.34,2.57h-1.3v1.71h2.16a4.36,4.36,0,0,1,2.83,1.05A4.25,4.25,0,0,1,16.7,19.8h0Z"/><path class="cls-3" d="M32.7,12.82a1.88,1.88,0,0,1,1,.64A1.74,1.74,0,0,1,34,14.55a1.79,1.79,0,0,1-.77,1.53,3.54,3.54,0,0,1-2.14.56H27.37V9.33h3.55a3.5,3.5,0,0,1,2,.5,1.58,1.58,0,0,1,.73,1.4,1.75,1.75,0,0,1-.26.94A1.78,1.78,0,0,1,32.7,12.82Zm-3.29-.57h1.32q.87,0,.87-.72t-.87-.72H29.41ZM31,15.16c.6,0,.9-.26.9-.77s-.3-.74-.9-.74H29.41v1.51Z"/><path class="cls-3" d="M38.27,12.73a2.61,2.61,0,0,1,1.68.5,1.79,1.79,0,0,1,.56,1.4,1.81,1.81,0,0,1-.66,1.49,2.77,2.77,0,0,1-1.83.52H35V11h2v1.75ZM41,11h2v5.66H41Zm-3.17,4.3c.5,0,.75-.23.75-.68a.6.6,0,0,0-.19-.49.93.93,0,0,0-.56-.17H37v1.33Z"/><path class="cls-3" d="M53.28,11v5.66h-9V11h2v4.07h1.53V11h2v4.07h1.53V11Z"/><path class="cls-3" d="M57.28,14.62h-.67v2h-2V11h2v2.09h.71L58.71,11h2.1l-1.9,2.71,2,3H58.59Z"/><path class="cls-3" d="M63.8,10.88a3.19,3.19,0,0,1,2.15.65,2.47,2.47,0,0,1,.74,2v3.15H64.84v-.73a1.7,1.7,0,0,1-1.67.82A2.52,2.52,0,0,1,62,16.5a1.77,1.77,0,0,1-.73-.61,1.73,1.73,0,0,1-.24-.9,1.41,1.41,0,0,1,.62-1.24,3.22,3.22,0,0,1,1.9-.45H64.7q0-.9-1.2-.9a2.65,2.65,0,0,0-.82.13,2.25,2.25,0,0,0-.71.36l-.67-1.35a3.5,3.5,0,0,1,1.14-.48A5.24,5.24,0,0,1,63.8,10.88Zm-.08,4.6a1.14,1.14,0,0,0,.61-.17.89.89,0,0,0,.37-.49v-.49h-.85q-.87,0-.87.57a.5.5,0,0,0,.2.42A.81.81,0,0,0,63.72,15.48Z"/><path class="cls-3" d="M27.32,19.77h3.46a4.83,4.83,0,0,1,2.13.45,3.39,3.39,0,0,1,1.44,1.28,3.91,3.91,0,0,1,0,3.86,3.37,3.37,0,0,1-1.44,1.27,4.83,4.83,0,0,1-2.13.45H27.32Zm3.37,5.66a2.09,2.09,0,0,0,1.51-.53,2.19,2.19,0,0,0,0-2.95,2.14,2.14,0,0,0-1.51-.53h-1.3v4Z"/><path class="cls-3" d="M35.85,21.42h2v5.66h-2Zm1-.62a1.27,1.27,0,0,1-.88-.31A1,1,0,0,1,36,19a1.27,1.27,0,0,1,.88-.3,1.24,1.24,0,0,1,.87.29.9.9,0,0,1,.34.73,1,1,0,0,1-.34.78A1.25,1.25,0,0,1,36.85,20.8Z"/><path class="cls-3" d="M45.22,21.42v4.63a3,3,0,0,1-.86,2.36,3.48,3.48,0,0,1-2.46.79A6.56,6.56,0,0,1,40.33,29a3.63,3.63,0,0,1-1.24-.56l.72-1.39a2.41,2.41,0,0,0,.86.44,3.6,3.6,0,0,0,1,.17,1.65,1.65,0,0,0,1.15-.35,1.35,1.35,0,0,0,.36-1v-.19a2.07,2.07,0,0,1-1.68.67,3,3,0,0,1-1.39-.33,2.66,2.66,0,0,1-1-1,2.77,2.77,0,0,1-.38-1.45,2.69,2.69,0,0,1,.38-1.42,2.66,2.66,0,0,1,1-1,2.89,2.89,0,0,1,1.39-.34,2.05,2.05,0,0,1,1.78.78v-.69ZM42,25.21a1.21,1.21,0,0,0,.88-.32,1.07,1.07,0,0,0,.35-.84,1.05,1.05,0,0,0-.34-.82,1.23,1.23,0,0,0-.89-.32,1.27,1.27,0,0,0-.9.32,1.05,1.05,0,0,0-.34.82,1.1,1.1,0,0,0,.35.84A1.27,1.27,0,0,0,42,25.21Z"/><path class="cls-3" d="M46.49,21.42h2v5.66h-2Zm1-.62a1.26,1.26,0,0,1-.88-.31,1,1,0,0,1,0-1.5,1.25,1.25,0,0,1,.88-.3,1.24,1.24,0,0,1,.87.29.9.9,0,0,1,.34.73,1,1,0,0,1-.34.78A1.25,1.25,0,0,1,47.49,20.8Z"/><path class="cls-3" d="M53.67,26.85a1.69,1.69,0,0,1-.61.24,3.13,3.13,0,0,1-.77.09,2.42,2.42,0,0,1-1.7-.55A2.1,2.1,0,0,1,50,25v-1.9h-.83V21.63H50V20.16h2v1.47h1.3v1.48H52V25a.65.65,0,0,0,.16.48.57.57,0,0,0,.44.17,1,1,0,0,0,.6-.18Z"/><path class="cls-3" d="M56.85,21.33A3.12,3.12,0,0,1,59,22a2.41,2.41,0,0,1,.74,2v3.14H57.9v-.73a1.72,1.72,0,0,1-1.68.83A2.65,2.65,0,0,1,55.09,27a1.73,1.73,0,0,1-.73-.62,1.68,1.68,0,0,1-.24-.9,1.43,1.43,0,0,1,.61-1.24,3.25,3.25,0,0,1,1.9-.45h1.13c0-.6-.44-.9-1.2-.9a2.73,2.73,0,0,0-.83.14,2.24,2.24,0,0,0-.71.35L54.36,22a3.54,3.54,0,0,1,1.13-.48A5.35,5.35,0,0,1,56.85,21.33Zm-.07,4.59a1.08,1.08,0,0,0,.6-.16.94.94,0,0,0,.38-.49v-.5H56.9c-.57,0-.86.2-.86.58a.5.5,0,0,0,.2.42A.87.87,0,0,0,56.78,25.92Z"/><path class="cls-3" d="M61,19.33h2v7.75H61Z"/></svg>
      <div class="top-menu__left__heading">
        {{ $store.getters.title }}
      </div>
    </div>
    <div class="top-menu__right">
      <div class="top-menu__right__panel" :class="{ disableLang: isLangDropdownDisabled, guest: !user }">
        <LangDropdown />
      </div>
      <div v-show="isLogined" class="top-menu__right__panel">
        <RolesDropdown id="top" />
        <HseSpace size='small_2x' horizontal />
        <HseDivider class="divider" color='light' variant='vertical'/>
        <HseSpace size='small_2x' horizontal />
        <router-link to="/messages" custom v-slot="{ isActive }" >
          <NotificationButton :isActive="isActive" />
        </router-link>
        <HseSpace size='small_2x' horizontal />
        <HseDivider class="divider" color='light' variant='vertical'/>
        <HseSpace size='small_2x' horizontal />
        <router-link to="/profile" custom v-slot="{ isActive }" >
          <UserDropdown :isActive="isActive" />
        </router-link>
      </div>
      <div class="top-menu__dividers" v-show="isLogined">
        <HseSpace size='small_2x' horizontal />
        <HseDivider class="divider" color='light' variant='vertical'/>
        <HseSpace size='small_2x' horizontal />
      </div>
      <div v-show="isLogined" class="hamburger">
        <HseHeaderHamburger @click.native="toggleSidebar" class="hseHeaderHamburger" />
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState } from "vuex";
  import LangDropdown from './LangDropdown'
  import RolesDropdown from './RolesDropdown'
  import NotificationButton from './NotificationButton'
  import UserDropdown from './UserDropdown'
  import {
    HseSpace,
    HseDivider,
    HseHeaderHamburger,
  } from '@hse-design/vue'

  export default {
    name: 'TopMenu',
    props: ['isLogined'],
    data: () => ({
      index: 0,
    }),
    components: {
      HseHeaderHamburger,
      HseSpace,
      HseDivider,
      LangDropdown,
      RolesDropdown,
      NotificationButton,
      UserDropdown,
    },
    computed: {
      ...mapState(['isLangDropdownDisabled', 'user'])
    },
    methods: {
      toggleSidebar () {
        this.$store.commit('setMenuState', !this.$store.state.isLeftMenuOpen)
      },
    },
  }
</script>

<style scoped>
  .cls-1,.cls-2{fill:#00aa3a;}.cls-2{fill-rule:evenodd;}.cls-3{fill:#002d6e;}
  .disableLang {
    opacity: 0.5;
  }
  .top-menu {
    height: 56px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #EDEFF3;
  }
  .top-menu__left {
    padding: 4px 8px;
    display: flex;
    align-items: center;
  }
  .top-menu__left svg {
    height: 48px;
    margin-right: 30px;
  }
  .top-menu__left__heading {
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    color: #6B7A99;
  }
  .top-menu__right {
    display: flex;
    align-items: center;
    margin-right: 60px;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    color: #6B7A99;
  }
  .top-menu__right__panel {
    display: flex;
    align-items: center;
    transition: opacity 0.2s ease;
  }
  .top-menu__right>.hamburger {
    display: none;
  }
  .divider {
    height: 20px;
  }
  .top-menu__dividers {
    display: none;
  }
  @media (max-width: 1024px) {
    .top-menu__right {
      margin-right: 8px;
    }
    .top-menu__dividers {
      display: flex;
      align-items: center;
    }
    .top-menu__right>.hamburger {
      display: block;
    }
  }
  @media (max-width: 767px) {
    .top-menu {
      height: 48px;
    }
    .top-menu__left__heading {
      display: none;
    }
    .top-menu__dividers {
      display: none;
    }
    .top-menu__right__panel {
      display: none;
    }
    .guest {
      display: block;
    }
  }
</style>
